import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { Capacitor } from "@capacitor/core";
import { Device } from "@capacitor/device";
import { sendPushNotificationToken } from "../ducks/app/notifications";
import { useAppDispatch } from "../redux-store";

export const useSendFirebaseToken = () => {
  const dispatch = useAppDispatch();

  const sendToken = () => {
    // Firebase is only initialized in the native apps; touching FirebaseMessaging
    // in the browser loads its web plugin, which throws app/no-app.
    if (!Capacitor.isNativePlatform()) {
      return Promise.resolve(null);
    }

    return Promise.all([
      FirebaseMessaging.getToken(),
      Device.getId(),
      Device.getInfo(),
    ]).then((values) => {
      const fcmToken = values[0].token;
      const deviceId = values[1].identifier;
      const platform = values[2].platform;

      if (platform === "web") {
        return null;
      }

      return dispatch(
        sendPushNotificationToken({ fcmToken, deviceId, platform })
      )
        .unwrap()
        .then(() => true);
    });
  };

  return { sendToken };
};
